'use strict';

const isMobileOrTabletWidth = () => {
    const desktopWidth = 1024;

    return $(window).width() < desktopWidth;
};

module.exports = isMobileOrTabletWidth;
